import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const Home = lazy(() => import("../pages/home/page"));
const About = lazy(() => import("../pages/about/page"));
const Contact = lazy(() => import("../pages/contact/page"));
const Listing = lazy(() => import("../pages/listing/page"));
const GetAQuote = lazy(() => import("../pages/get-a-quote/page"));
const ListingBantryBay = lazy(() => import("../pages/listing-painters-bantry-bay/page"));
const ListingBellvillePainters = lazy(() => import("../pages/listing-painters-bellville-painters/page"));
const ListingBigBay = lazy(() => import("../pages/listing-painters-big-bay/page"));
const ListingBishopscourt = lazy(() => import("../pages/listing-painters-bishopscourt/page"));
const ListingBloubergstrand = lazy(() => import("../pages/listing-painters-bloubergstrand/page"));
const ListingBothasig = lazy(() => import("../pages/listing-painters-bothasig/page"));
const ListingBrackenfell = lazy(() => import("../pages/listing-painters-brackenfell/page"));
const ListingCampsBay = lazy(() => import("../pages/listing-painters-camps-bay/page"));
const ListingCapeTown = lazy(() => import("../pages/listing-painters-cape-town/page"));
const ListingCenturyCity = lazy(() => import("../pages/listing-painters-century-city/page"));
const ListingClaremont = lazy(() => import("../pages/listing-painters-claremont/page"));
const ListingClifton = lazy(() => import("../pages/listing-painters-clifton/page"));
const ListingConstantia = lazy(() => import("../pages/listing-painters-constantia/page"));
const ListingDurbanville = lazy(() => import("../pages/listing-painters-durbanville/page"));
const ListingEdgemead = lazy(() => import("../pages/listing-painters-edgemead/page"));
const ListingFishHoek = lazy(() => import("../pages/listing-painters-fish-hoek/page"));
const ListingGeorge = lazy(() => import("../pages/listing-painters-george/page"));
const ListingGoodwood = lazy(() => import("../pages/listing-painters-goodwood/page"));
const ListingGreenPoint = lazy(() => import("../pages/listing-painters-green-point/page"));
const ListingHermanus = lazy(() => import("../pages/listing-painters-hermanus/page"));
const ListingHoutBay = lazy(() => import("../pages/listing-painters-hout-bay/page"));
const ListingKenilworth = lazy(() => import("../pages/listing-painters-kenilworth/page"));
const ListingKirstenhof = lazy(() => import("../pages/listing-painters-kirstenhof/page"));
const ListingMalmesbury = lazy(() => import("../pages/listing-painters-malmesbury/page"));
const ListingMelkbosstrand = lazy(() => import("../pages/listing-painters-melkbosstrand/page"));
const ListingMuizenberg = lazy(() => import("../pages/listing-painters-muizenberg/page"));
const ListingNewlands = lazy(() => import("../pages/listing-painters-newlands/page"));
const ListingPaarl = lazy(() => import("../pages/listing-painters-paarl/page"));
const ListingParklands = lazy(() => import("../pages/listing-painters-parklands/page"));
const ListingParow = lazy(() => import("../pages/listing-painters-parow/page"));
const ListingPlattekloof = lazy(() => import("../pages/listing-painters-plattekloof/page"));
const ListingPlumstead = lazy(() => import("../pages/listing-painters-plumstead/page"));
const ListingProPaintersMilnerton = lazy(() => import("../pages/listing-painters-pro-painters-milnerton/page"));
const ListingRondebosch = lazy(() => import("../pages/listing-painters-rondebosch/page"));
const ListingSeaPoint = lazy(() => import("../pages/listing-painters-sea-point/page"));
const ListingSimonsTown = lazy(() => import("../pages/listing-painters-simons-town/page"));
const ListingSomersetWest = lazy(() => import("../pages/listing-painters-somerset-west/page"));
const ListingSunningdale = lazy(() => import("../pages/listing-painters-sunningdale/page"));
const ListingTableView = lazy(() => import("../pages/listing-painters-table-view/page"));
const ListingTamboerskloof = lazy(() => import("../pages/listing-painters-tamboerskloof/page"));
const ListingTokai = lazy(() => import("../pages/listing-painters-tokai/page"));
const ListingVredehoek = lazy(() => import("../pages/listing-painters-vredehoek/page"));
const ListingWestBeach = lazy(() => import("../pages/listing-painters-west-beach/page"));
const ListingWoodstock = lazy(() => import("../pages/listing-painters-woodstock/page"));
const ListingWynberg = lazy(() => import("../pages/listing-painters-wynberg/page"));
const ListingPaintersCapeTownMain = lazy(() => import("../pages/listing-painters-cape-town-main/page"));
const ListingPaintersWC = lazy(() => import("../pages/listing-painters-wc/page"));
const ListingPaintingContractorsCapeTown = lazy(() => import("../pages/listing-painting-contractors-cape-town/page"));
const ListingDurbanvillePaintersMain = lazy(() => import("../pages/listing-durbanville-painters-main/page"));
const ListingDurbanvillePaintersAlt = lazy(() => import("../pages/listing-durbanville-painters-alt/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

const PaintersJohannesburgPage = lazy(() => import('../pages/listing-painters-johannesburg/page'));
const PaintersJhbPage = lazy(() => import('../pages/listing-painters-jhb/page'));
const PaintersSimonsTownPage = lazy(() => import('../pages/listing-painters-simons-town/page'));
const PaintersNoordhoekPage = lazy(() => import('../pages/listing-painters-noordhoek/page'));
const PaintersDeWaterkantPage = lazy(() => import('../pages/listing-painters-de-waterkant/page'));
const PaintersKommetjiePage = lazy(() => import('../pages/listing-painters-kommetjie/page'));
const PaintersSandownPage = lazy(() => import('../pages/listing-painters-sandown/page'));
const PaintersKalkBayPage = lazy(() => import('../pages/listing-painters-kalk-bay/page'));
const PaintersRoyalAscotPage = lazy(() => import('../pages/listing-painters-royal-ascot/page'));
const PaintersTygerbergPage = lazy(() => import('../pages/listing-painters-tygerberg/page'));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/get-a-quote",
    element: <GetAQuote />,
  },
  {
    path: "/listing",
    element: <Listing />,
  },
  {
    path: "/listing-painters-bantry-bay",
    element: <ListingBantryBay />,
  },
  {
    path: "/listing-painters-bellville-painters",
    element: <ListingBellvillePainters />,
  },
  {
    path: "/listing-painters-big-bay",
    element: <ListingBigBay />,
  },
  {
    path: "/listing-painters-bishopscourt",
    element: <ListingBishopscourt />,
  },
  {
    path: "/listing-painters-bloubergstrand",
    element: <ListingBloubergstrand />,
  },
  {
    path: "/listing-painters-bothasig",
    element: <ListingBothasig />,
  },
  {
    path: "/listing-painters-brackenfell",
    element: <ListingBrackenfell />,
  },
  {
    path: "/listing-painters-camps-bay",
    element: <ListingCampsBay />,
  },
  {
    path: "/listing-painters-cape-town",
    element: <ListingCapeTown />,
  },
  {
    path: "/listing-painters-century-city",
    element: <ListingCenturyCity />,
  },
  {
    path: "/listing-painters-claremont",
    element: <ListingClaremont />,
  },
  {
    path: "/listing-painters-clifton",
    element: <ListingClifton />,
  },
  {
    path: "/listing-painters-constantia",
    element: <ListingConstantia />,
  },
  {
    path: "/listing-painters-durbanville",
    element: <ListingDurbanville />,
  },
  {
    path: "/listing-painters-edgemead",
    element: <ListingEdgemead />,
  },
  {
    path: "/listing-painters-fish-hoek",
    element: <ListingFishHoek />,
  },
  {
    path: "/listing-painters-george",
    element: <ListingGeorge />,
  },
  {
    path: "/listing-painters-goodwood",
    element: <ListingGoodwood />,
  },
  {
    path: "/listing-painters-green-point",
    element: <ListingGreenPoint />,
  },
  {
    path: "/listing-painters-hermanus",
    element: <ListingHermanus />,
  },
  {
    path: "/listing-painters-hout-bay",
    element: <ListingHoutBay />,
  },
  {
    path: "/listing-painters-kenilworth",
    element: <ListingKenilworth />,
  },
  {
    path: "/listing-painters-kirstenhof",
    element: <ListingKirstenhof />,
  },
  {
    path: "/listing-painters-malmesbury",
    element: <ListingMalmesbury />,
  },
  {
    path: "/listing-painters-melkbosstrand",
    element: <ListingMelkbosstrand />,
  },
  {
    path: "/listing-painters-muizenberg",
    element: <ListingMuizenberg />,
  },
  {
    path: "/listing-painters-newlands",
    element: <ListingNewlands />,
  },
  {
    path: "/listing-painters-paarl",
    element: <ListingPaarl />,
  },
  {
    path: "/listing-painters-parklands",
    element: <ListingParklands />,
  },
  {
    path: "/listing-painters-parow",
    element: <ListingParow />,
  },
  {
    path: "/listing-painters-plattekloof",
    element: <ListingPlattekloof />,
  },
  {
    path: "/listing-painters-plumstead",
    element: <ListingPlumstead />,
  },
  {
    path: "/listing-painters-pro-painters-milnerton",
    element: <ListingProPaintersMilnerton />,
  },
  {
    path: "/listing-painters-rondebosch",
    element: <ListingRondebosch />,
  },
  {
    path: "/listing-painters-sea-point",
    element: <ListingSeaPoint />,
  },
  {
    path: "/listing-painters-simons-town",
    element: <ListingSimonsTown />,
  },
  {
    path: "/listing-painters-somerset-west",
    element: <ListingSomersetWest />,
  },
  {
    path: "/listing-painters-sunningdale",
    element: <ListingSunningdale />,
  },
  {
    path: "/listing-painters-table-view",
    element: <ListingTableView />,
  },
  {
    path: "/listing-painters-tamboerskloof",
    element: <ListingTamboerskloof />,
  },
  {
    path: "/listing-painters-tokai",
    element: <ListingTokai />,
  },
  {
    path: "/listing-painters-vredehoek",
    element: <ListingVredehoek />,
  },
  {
    path: "/listing-painters-west-beach",
    element: <ListingWestBeach />,
  },
  {
    path: "/listing-painters-woodstock",
    element: <ListingWoodstock />,
  },
  {
    path: "/listing-painters-wynberg",
    element: <ListingWynberg />,
  },
  {
    path: "/listing-painters-cape-town-main",
    element: <ListingPaintersCapeTownMain />,
  },
  {
    path: "/listing-painters-wc",
    element: <ListingPaintersWC />,
  },
  {
    path: "/listing-painting-contractors-cape-town",
    element: <ListingPaintingContractorsCapeTown />,
  },
  {
    path: "/listing-durbanville-painters-main",
    element: <ListingDurbanvillePaintersMain />,
  },
  {
    path: "/listing-durbanville-painters-alt",
    element: <ListingDurbanvillePaintersAlt />,
  },
  {
    path: '/listing-painters-johannesburg',
    element: <PaintersJohannesburgPage />
  },
  {
    path: '/listing-painters-jhb',
    element: <PaintersJhbPage />
  },
  {
    path: '/listing-painters-simons-town',
    element: <PaintersSimonsTownPage />
  },
  {
    path: '/listing-painters-noordhoek',
    element: <PaintersNoordhoekPage />
  },
  {
    path: '/listing-painters-de-waterkant',
    element: <PaintersDeWaterkantPage />
  },
  {
    path: '/listing-painters-kommetjie',
    element: <PaintersKommetjiePage />,
  },
  {
    path: '/listing-painters-sandown',
    element: <PaintersSandownPage />,
  },
  {
    path: '/listing-painters-kalk-bay',
    element: <PaintersKalkBayPage />,
  },
  {
    path: '/listing-painters-royal-ascot',
    element: <PaintersRoyalAscotPage />,
  },
  {
    path: '/listing-painters-tygerberg',
    element: <PaintersTygerbergPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
